import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { aliases, mdi } from "vuetify/iconsets/mdi";
import { h } from "vue";
import { getColorsFromStorage } from "../Helpers/colorPalette.js";

const savedTheme = getColorsFromStorage();

export default createVuetify({
    components,
    directives,
    theme: {
        defaultTheme: "light",
        themes: {
            light: {
                dark: false,
                colors: savedTheme,
            },
        },
    },
    defaults: {
        global: {
            ripple: false,
        },
    },
    icons: {
        defaultSet: "mdi", // keep mdi as default
        aliases,
        sets: {
            mdi,
            symbols: {
                component: (props) =>
                    h(
                        "span",
                        {
                            class: "material-symbols-rounded",
                            style: "font-size: inherit;",
                        },
                        props.icon,
                    ),
            },
        },
    },
});
